import apiV2Service from 'common/src/modules/api/api-v2.service';
import {ToolExecuteParams, ToolResult} from 'common/src/modules/shared/copilot/copilot.types';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import {z} from 'zod';
import {CreativeTemplatesManagerAgentToolName} from '../creativeTemplatesManagetAgent.enums';
import tool from 'common/src/modules/shared/copilot/utils/creators/tool';

const inputSchema = z.object({
  templateName: z.string(),
});

function getTemplatesIdsByNameTool() {
  async function execute({
    input: {templateName},
  }: ToolExecuteParams<typeof inputSchema>): Promise<ToolResult> {
    try {
      const {data: templates} = await apiV2Service.executeGetRequest<
        Array<{id: number; name: string}>
      >(`Templates/bestMatchByName/${encodeURIComponent(templateName)}`);

      return toolResult(JSON.stringify(templates));
    } catch (error) {
      return toolResult(
        JSON.stringify({
          message: 'Error occurred while searching for templates',
          error: error instanceof Error ? error.message : 'Unknown error',
        }),
      );
    }
  }

  return tool({
    name: CreativeTemplatesManagerAgentToolName.GetTemplateByName,
    description:
      'Get specific template id by name. If found multiple templates with similar names, return all their ids and names',
    displayName: 'Searching template by name',
    execute,
    inputSchema,
  });
}

export default getTemplatesIdsByNameTool;
